import { useEffect } from 'react';

export const useKeyUp = (key, action) => {
  useEffect(() => {
    function onKeyUp(event) {
      if (event?.key === key) {
        action();
      }
    }
    window.addEventListener('keyup', onKeyUp);

    return () => window.removeEventListener('keyup', onKeyUp);
  }, [action, key]);
};
